import React from "react";
import styled from "styled-components";

import BodyLayout from "./BodyLayout";
import SEO from "./SEO";

import { useTocHeaderQuery } from "./ContextWrapper";

const ResponsiveMargin = styled.div`
	margin: 2em 0.3% 0.8em 15px;
`;
// eslint-disable-next-line react/display-name
const PageLayout = ({
	location,
	rewriteNavPaths,
	pageTitle,
	data,
	tocQuery,
	renderPage,
}) => {
	useTocHeaderQuery(tocQuery);
	return (
		<BodyLayout location={location} rewriteNavPaths={rewriteNavPaths}>
			<SEO title={pageTitle} />
			<ResponsiveMargin>
				<div id="main-content" className="mx-xl-5">
					{renderPage({ data: data, location: location })}
				</div>
			</ResponsiveMargin>
		</BodyLayout>
	);
};

export default PageLayout;
